import { __rest } from "tslib";
import React from 'react';
import kinds from './kinds';
import sizes from './sizes';
import { BadgeElement } from './styles';
export default function Badge(_a) {
    var { children, kind = 'default', size = 0, textAlign = 'center' } = _a, props = __rest(_a, ["children", "kind", "size", "textAlign"]);
    return (React.createElement(BadgeElement, Object.assign({ display: "flex", fontWeight: 500, textAlign: textAlign }, sizes[size], kinds[kind], props), children));
}
